const Home = () => {
  return (
    <section className="min-h-[calc(100vh-68px)] pt-[120px] text-center">
      <h1 className="text-4xl">Welcome to the Dashboard!</h1>
    </section>
  );
};

export default Home;
